import { createSlice } from "@reduxjs/toolkit";
import { getCart } from "utils/requests/getRequest";
import { AppDispatch } from "store";

export interface CartState {
  cart: any[];
}

const cartSlice = createSlice({
  name: "cart",
  initialState: { cart: [] } as CartState,
  reducers: {
    addToCart: (state, action) => {
      state.cart.push({ ...action.payload, quantity: 1 });
    },
    cart: (state, action) => {
      state.cart = action.payload;
    },
  },
});

export const setUpCart = (test?: any) => {
  return async (dispatch: AppDispatch) => {
    const data = await getCart();
    dispatch(cart(data?.items));
  };
};

export const { addToCart, cart } = cartSlice.actions;
export const cartReducer = cartSlice.reducer;
